// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
export function dateBetween(startDate: any, endDate: any, countDays = true) {
  const second = 1000;
  const minute = second * 60;
  const hour = minute * 60;
  const day = hour * 24;
  const distance = endDate - startDate;

  const diff = {
    days: 0,
    hours: 0,
    fullHours: 0,
    minutes: 0,
    seconds: 0,
    distance,
  };

  if (distance < 0) {
    return diff;
  }

  const days = Math.floor(distance / day);
  const hours = Math.floor((distance % day) / hour);
  const fullHours = Math.floor(distance / hour);
  const minutes = Math.floor((distance % hour) / minute);
  const seconds = Math.floor((distance % minute) / second);

  Object.assign(diff, {
    days,
    hours,
    fullHours,
    minutes,
    seconds,
  });

  return diff;
}

export function monthDiff(d1: any, d2: any) {
  let months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth() + 1;
  months += d2.getMonth();
  return months <= 0 ? 0 : months;
}

export function daysDiff(d1: any, d2: any) {
  const diffTime = Math.abs(d2.getTime() - d1.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays <= 0 ? 0 : diffDays;
}

export function dateDiffInHumanReadable(startDate: any, endDate: any) {
  const years = endDate.getFullYear() - startDate.getFullYear();
  const months = monthDiff(startDate, endDate);
  const daysHours = dateBetween(startDate, endDate);
  if (years > 0) {
    return `${years} years ago`;
  }
  if (months > 0) {
    return `${months} months ago`;
  }
  if (daysHours.days > 0) {
    return `${daysHours.days} days ago`;
  }
  if (daysHours.fullHours > 0) {
    return `${daysHours.fullHours} hours ago`;
  }
  if (daysHours.minutes > 0) {
    return `${daysHours.minutes} minutes ago`;
  }
  if (daysHours.seconds > 0) {
    return `${daysHours.seconds} seconds ago`;
  }
  return "-";
}

export function dateToYMD(date: any, onlyDate?: boolean) {
  const strArray = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const d = date.getDate();
  const m = strArray[date.getMonth()];
  const y = date.getFullYear();
  const time = date.toLocaleString("en-US", { hour: "numeric", minute: "numeric", hour12: true });
  if (onlyDate) {
    return `${d <= 9 ? `0${d}` : d}-${m}-${y}`;
  }
  return `${d <= 9 ? `0${d}` : d}-${m}-${y},  ${time}`;
}

export function hasDST() {
  // const March = new Date(date.getFullYear(), 2, 13).getTimezoneOffset();
  // const November = new Date(date.getFullYear(), 10, 6).getTimezoneOffset();
  // return Math.max(March, November) !== date.getTimezoneOffset();
  return false;
}

// function convertUTCToEstTime() {
//   let hours = new Date().getUTCHours();
//   hours -= 4;
//   if (hours < 0) { // one day before i.e before 12 midnight
//     hours = 24 + hours;
//   }
//   return hours;
// }

export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
}

export function formatCountdownTime(totalSeconds: number): string {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}

// export const getRemainingDeliveryTimeRange = (startTime: number, endTime: number) : {hours: number, minutes: number} => {
//   const hours = convertUTCToEstTime();
//   if (hours >= startTime && hours < endTime) {
//     const currentMinutes = new Date().getUTCMinutes();
//     const remainingMinutes = (60 - currentMinutes) % 60; // remaining minutes = 60 => it will shown as X hrs and 0 mins;
//     let remainingHours = endTime - hours;
//     if (currentMinutes !== 0) { // As 60 - 0 = 60 -> If we don't subtract 1 then on UI it will come as 1hr 60 mins.
//       remainingHours -= 1;
//     }
//     return {
//       hours: remainingHours,
//       minutes: remainingMinutes,
//     };
//   }
//   return {
//     hours: -1,
//     minutes: -1,
//   };
// };

export function getChatOnlineTime() {
  // Chat is always online for now.
  return true;
  /*
  const now = new Date();
  const estHour = parseInt(
    now.toLocaleString("en-CA", { timeZone: "America/Toronto", hour: "numeric", hour12: false }),
    10,
  );

  // Saturday, June 6 2026: chat closes early at 6 PM EST. Regular hours resume Sunday.
  const estDate = now.toLocaleDateString("en-CA", { timeZone: "America/Toronto" }); // YYYY-MM-DD

  if (estDate === "2026-06-06") {
    // Online from 5 AM to 6 PM EST
    return estHour >= 5 && estHour < 18;
  }

  // Online from 5 AM to 10 PM EST
  return estHour >= 5 && estHour < 22;
  */
}

export function getTorontoToday(): Date {
  const now = new Date();
  // Get Toronto's Y-M-D as a string, unaffected by server's local timezone
  const torontoDateStr = now.toLocaleDateString("en-CA", { timeZone: "America/Toronto" });
  // en-CA locale gives YYYY-MM-DD format

  const [year, month, day] = torontoDateStr.split("-").map(Number);
  // Construct a local Date at midnight for that Y-M-D
  return new Date(year, month - 1, day);
}
